var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"blue-grey darken-2 text-white","dark":"","dense":""}},[_c('v-container',{attrs:{"text-center":""}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("fas fa-copyright")]),_vm._v(_vm._s(_vm.year)+" "),_c('span',{staticClass:"font-weight-light ml-2"},[_vm._v(_vm._s(_vm.footer))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }